module.exports = __webpack_public_path__ + "img/12_1.252354b7.jpg";